import { useEffect } from 'react'
import { useLocation } from '@tanstack/react-router'

const DEFAULT_OPTIONS: ScrollIntoViewOptions = { behavior: 'smooth', block: 'start' }

/**
 * Scrolls the element whose `id` matches the current location hash into view.
 *
 * No-op when there is no hash or no matching element. Re-runs whenever the hash
 * changes, so it handles both initial deep links (e.g. `/page#section`) and
 * in-app navigation to a new hash.
 *
 * @param options - Passed to `scrollIntoView`. Defaults to a smooth scroll to the
 *                   top of the element. Pass a stable/memoized object if overriding,
 *                   to avoid re-running on every render.
 */
export const useScrollToHash = (options: ScrollIntoViewOptions = DEFAULT_OPTIONS) => {
  const { hash } = useLocation()

  useEffect(() => {
    if (!hash) return
    document.getElementById(hash)?.scrollIntoView(options)
  }, [hash, options])
}
